import React, { useEffect, useState } from "react";
import { Buildings, GlobeStand } from "@phosphor-icons/react";

// Session hours in UTC (approx, no DST adjustments).
const SESSIONS = [
  { name: "Sydney",   city: "Sydney",   openUtc: 22, closeUtc: 7,  tone: "text-amber-300"  },
  { name: "Tokyo",    city: "Tokyo",    openUtc: 0,  closeUtc: 9,  tone: "text-red-300"    },
  { name: "London",   city: "London",   openUtc: 8,  closeUtc: 17, tone: "text-sky-300"    },
  { name: "New York", city: "New York", openUtc: 13, closeUtc: 22, tone: "text-emerald-300" },
];

function inSession(hourUtc, open, close) {
  return open <= close ? (hourUtc >= open && hourUtc < close) : (hourUtc >= open || hourUtc < close);
}

function hoursUntil(hourUtc, targetHour) {
  let diff = targetHour - hourUtc;
  if (diff <= 0) diff += 24;
  return diff;
}

export default function MarketHours() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(t);
  }, []);
  const uh = now.getUTCHours();

  return (
    <div className="rounded-2xl border border-border bg-card p-4 sm:p-6" data-testid="market-hours-card">
      <div className="flex items-start justify-between mb-4 gap-2">
        <div className="min-w-0">
          <p className="text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-muted-foreground flex items-center gap-1">
            <GlobeStand size={12} /> Sessions
          </p>
          <h3 className="font-display text-base sm:text-lg font-semibold mt-1">Market Hours</h3>
          <p className="text-[10px] text-muted-foreground mt-0.5">
            UTC {String(uh).padStart(2,"0")}:{String(now.getUTCMinutes()).padStart(2,"0")} — session times are approximate (no DST)
          </p>
        </div>
        <Buildings size={22} className="text-muted-foreground" />
      </div>

      <div className="grid grid-cols-2 gap-2">
        {SESSIONS.map(s => {
          const open = inSession(uh, s.openUtc, s.closeUtc);
          const nextEvent = open
            ? `closes in ${hoursUntil(uh, s.closeUtc)}h`
            : `opens in ${hoursUntil(uh, s.openUtc)}h`;
          return (
            <div key={s.name} data-testid={`session-${s.name.toLowerCase().replace(" ","-")}`}
              className={`rounded-lg border p-3 transition-colors ${
                open ? "border-emerald-500/40 bg-emerald-500/5" : "border-border/60 bg-secondary/30"
              }`}>
              <div className="flex items-center gap-2 mb-1">
                <span className={`w-2 h-2 rounded-full ${open ? "bg-emerald-400 animate-pulse" : "bg-muted-foreground/40"}`} />
                <p className={`text-sm font-semibold ${s.tone}`}>{s.name}</p>
              </div>
              <p className="text-[10px] text-muted-foreground font-mono">
                {String(s.openUtc).padStart(2,"0")}:00 → {String(s.closeUtc).padStart(2,"0")}:00 UTC
              </p>
              <p className={`text-[10px] mt-1 ${open ? "text-emerald-400" : "text-muted-foreground"}`}>
                {open ? "OPEN · " : "CLOSED · "}{nextEvent}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
